import {menuStore} from "@/store/store.js";

/*判断是否存在按钮操作权限*/
export function hasBtnPermission(mode = 'any', ...points) {
    try {
        const permissionList = menuStore().menu.permissionCodeList;
        if (!permissionList) {
            console.log("暂无菜单信息")
        }
        if (mode === 'all') {
            return points.every(point => permissionList.includes(point));
        } else if (mode === 'any') {
            return points.some(point => permissionList.includes(point));
        }
        return false;
    } catch (e) {
        console.log(e)
    }
}
